import { render, staticRenderFns } from "./BulkDispatch.vue?vue&type=template&id=25c560a0&scoped=true&"
import script from "./BulkDispatch.vue?vue&type=script&lang=js&"
export * from "./BulkDispatch.vue?vue&type=script&lang=js&"
import style0 from "./BulkDispatch.vue?vue&type=style&index=0&id=25c560a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c560a0",
  null
  
)

export default component.exports